import { LayoutComponent } from "@jelly/lesson";
import variables from "../../../../../../../assets/styles/sass-resources.scss";
import config from "appConfig";

const components: LayoutComponent[] = [
  {
    variant: "layout",
    data: {
      type: "table",
      options: {
        cols: 2,
        rows: 2,
        colsSize: [1, 2],
        rowsSize: [0, 0],
        rowSpan: {
          "0:1": 2,
        },
        gap: "10px",
        components: [
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "image",
                  options: {
                    src: `${config.ASSETS_URL}/02/case01/slide04-reproduction-image01.svg`,
                    styles: {
                      height: "250px",
                    },
                  },
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "image",
                  options: {
                    src: `${config.ASSETS_URL}/02/case01/slide04-reproduction-image02.svg`,
                    styles: {
                      height: "455px",
                      width: "662px",
                    },
                  },
                },
              },
            },
          ],
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "text",
                  options: {
                    scrollbars: false,
                    data:
                      "The reproduction of calibrated binaural recordings, and of any sounds where the spectral characteristics or the signal level are of relevance for the assessment, needs to be performed by means of a calibrated and equalized reproduction system. Although binaural signals can be reproduced through loudspeakers using cross talk cancellation, the most common and cost-effective solution relies on headphone reproduction. This allows for better control and separation between the left and right ear channels, and the participation of many individuals in a single session.",
                    styles: {
                      fontSize: "12px",
                      fontWeight: 600,
                    },
                  },
                },
                styles: {
                  width: "93%",
                  alignItems: "flex-start",
                },
              },
            },
          ],
        ],
      },
      styles: {
        borderBottom: `solid 1px ${variables["default-light"]}`,
      },
    },
  },
];

export default components;
